/**
*
* RedAgendaPresentation
*
*/

import React from 'react';
import PropTypes from 'prop-types';

import moment from 'moment-timezone';

import setLanguageContent from 'helpers/setLanguageContent';
import Wrapper from 'components/Templates/dynamics/Wrapper';
import PresentationTagsWrapper from './styles/PresentationTagsWrapper'
import RedSpeakersSpeaker from 'components/Templates/components/speakers/RedSpeakers/RedSpeakersSpeaker';

import selectSpeakerById from 'helpers/selectSpeakerById';

import PresentationWrapper from './styles/PresentationWrapper';
import TagTextWrapper from 'components/Tag/styles/TagTextWrapper';

class RedAgendaPresentation extends React.PureComponent {

  constructor() {
    super();

    this.state = {
      prevPresentationDisabled: false,
      nextPresentationDisabled: false,
    }

    this.handleClick = this.handleClick.bind(this);
    this.handlePresentationToggle = this.handlePresentationToggle.bind(this);
    this.handlePrevPresentation = this.handlePrevPresentation.bind(this);
    this.handleNextPresentation = this.handleNextPresentation.bind(this);
    this.handleHideShowArrows = this.handleHideShowArrows.bind(this);
  }

  handleClick() {

    const {
      presentation,
      isSingle,
      handleShowPresentation,
    } = this.props;

    handleShowPresentation(isSingle ? '' : presentation);
  }

  handlePresentationToggle(goBack) {

    const {
      presentation,
      handleShowPresentation,
      allSortedDayPresentations
    } = this.props;

    if (goBack) {
      handleShowPresentation(allSortedDayPresentations[allSortedDayPresentations.findIndex(presentationItem => presentationItem.presentationId === presentation.presentationId) - 1]);
    } else {
      handleShowPresentation(allSortedDayPresentations[allSortedDayPresentations.findIndex(presentationItem => presentationItem.presentationId === presentation.presentationId) + 1]);
    }
  }

  handlePrevPresentation() {
    this.handlePresentationToggle(true);
  }

  handleNextPresentation() {
    this.handlePresentationToggle();
  }

  handleHideShowArrows() {
    const {
      presentation,
      allSortedDayPresentations
    } = this.props;


    if (allSortedDayPresentations) {

      if (allSortedDayPresentations.findIndex(presentationItem => presentationItem.presentationId === presentation.presentationId) === 0) {
        this.setState({
          prevPresentationDisabled: true,
        });
      } else {
        this.setState({
          prevPresentationDisabled: false
        });
      }

      if (allSortedDayPresentations.findIndex(presentationItem => presentationItem.presentationId === presentation.presentationId) === allSortedDayPresentations.length - 1) {
        this.setState({
          nextPresentationDisabled: true,
        });
      } else {
        this.setState({
          nextPresentationDisabled: false
        });
      }
    }
  }

  componentDidMount() {
    this.handleHideShowArrows();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.presentation !== this.props.presentation) {
      this.handleHideShowArrows();
    }
  }



  render() {

    const {
      commonData,
      openEditor,
      commonProps,
      presentation,
      firstHour,
      firstHourMinutes,
      speakers,
      index,
      trackCount,
      isSingle,
      top,
      blurredTop,
      blurredBottom,
      companies,
      language,
      offsetString,
      tracksLength,
      allSortedDayPresentations,
      viewRef,
      availableTags,
      handleIsTagActive
    } = this.props;

    const {
      dateFrom,
      dateTo,
      rowNumber,
      startHour,
      startMinutes,
      trackKey,
      diff,
      diffMinutes,
      isBreak,
      trackTitle,
      tags
    } = presentation;

    const {
      timezone,
      styling,
    } = commonProps;

    const {
      componentPayload,
      customStyles
    } = commonData;

    const {
      companyLogoType,
      sectionId
    } = componentPayload;

    const {
      nextPresentationDisabled,
      prevPresentationDisabled
    } = this.state;

    

    const start = moment(dateFrom).tz(timezone);

    const end = moment(dateTo).tz(timezone);

    const duration = moment.duration(end.diff(start));

    let durationInHours = Math.round(duration.asHours() / 0.5) * 0.5;



    let getHoursOffset = Number(startHour) - Number(firstHour);


    if (getHoursOffset >= 1) getHoursOffset = getHoursOffset + getHoursOffset;

    let minutesHeight = parseInt((100 * startMinutes) / 60);
    let calculateMinutes = parseInt((100 * startMinutes) / 60) * 2;

    if (calculateMinutes >= 100) {
      getHoursOffset = getHoursOffset + 1;
      minutesHeight = calculateMinutes - 100;
      getHoursOffset = getHoursOffset + '.' + minutesHeight;
    } else {
      getHoursOffset = getHoursOffset + '.' + calculateMinutes;
    }


    const thisCompanyLogoType = companyLogoType ? companyLogoType : 'colorLogo';


    const heightContainer = styling && styling.rulerBlock && styling.rulerBlock[0] ? diff * (parseInt(styling.rulerBlock[0].height) / 20) : 20;

    let thisSpeakerList = presentation && presentation.speakers ? presentation.speakers : '';

    if (thisSpeakerList) thisSpeakerList = thisSpeakerList.map((speaker) => {
      const thisSpeaker = selectSpeakerById(speakers, speaker);
      if (thisSpeaker) return thisSpeaker;
    }).filter((a) => a);

    const speakersLength = thisSpeakerList ? thisSpeakerList.length : 0;

    const companiesList = [];
    const companiesListHash = [];

    const speakerContent = thisSpeakerList && speakersLength > 0 && heightContainer > 15 && !isBreak || isSingle && !isBreak ? thisSpeakerList.map((thisSpeaker, i) => {

      if (thisSpeaker.speakerCompany && !companiesListHash.includes(thisSpeaker.speakerCompany.companieId)) {

        companiesListHash.push(thisSpeaker.speakerCompany.companieId);

        companiesList.push(
          (
            <Wrapper
              {...commonProps}

              typeOfStyle={'presentationCompanyLogo'}
              key={'presentationCompanyLogo-' + sectionId + thisSpeaker.speakerCompany.companieId}
              editorData={
                {
                  editorType: 'presentationCompanyLogo',
                  ...commonData
                }
              }
              backgroundImage={thisSpeaker.speakerCompany[thisCompanyLogoType]}
            />
          )
        );
      }


      return (
        <RedSpeakersSpeaker
          key={'RedSpeakersSpeaker-' + thisSpeaker.speakerId}
          commonData={commonData}
          commonProps={commonProps}
          thisSpeaker={thisSpeaker}
          speakerCompany={thisSpeaker.speakerCompany}
          companyLogoType={companyLogoType}
          hideLogo={true}
          tracksLength={tracksLength}
          speakersLength={speakersLength}
          showDetails={diffMinutes >= 45}
          diffMinutes={diffMinutes}
          isSingle={isSingle}
        />
      );

    }) : '';

    const hasDescriptionContent = setLanguageContent(presentation, 'description', language);
    const lines = parseInt(diffMinutes / 10);

    const descriptionContent = hasDescriptionContent && diff >= 50 || isSingle ? (
      <Wrapper
        {...commonProps}

        typeOfStyle={isSingle ? 'presentationDescriptionSingle' : 'presentationDescription'}
        lineClamp={tags && speakersLength > 2 && diffMinutes < 60 ? 1 : isSingle ? 0 : lines >= 6 ? lines - 3 : 3}
        editorData={
          {
            editorType: isSingle ? 'presentationDescriptionSingle' : 'presentationDescription',
            ...commonData
          }
        }
      >
        {hasDescriptionContent}
      </Wrapper>
    ) : '';

    const presentationContent = (<Wrapper
      {...commonProps}

      typeOfStyle={isBreak && !isSingle
        ? 'presentationBreak'
        : isSingle ? 'presentationContainerSingle' : 'presentationContainer'}
      forceStopPropagation={true}
      editorData={
        {
          editorType: isBreak && !isSingle
            ? 'presentationBreak'
            : isSingle ? 'presentationContainerSingle' : 'presentationContainer',
          ...commonData
        }
      }
    >
      {
        isSingle ? (
          <Wrapper
            {...commonProps}

            typeOfStyle={'presentationTrackTitle'}
            editorData={
              {
                editorType: 'presentationTrackTitle',
                ...commonData
              }
            }
          >
            {trackTitle}
          </Wrapper>

        ) : ''
      }
      {

        diffMinutes > 10 || isSingle ? (
          <Wrapper
            {...commonProps}

            typeOfStyle={'presentationTime'}
            editorData={
              {
                editorType: 'presentationTime',
                ...commonData
              }
            }
          >
            {`${startHour}:${startMinutes} - ${end.format('HH:mm')} | ${offsetString ? offsetString : ''}`}
          </Wrapper>

        ) : ''
      }

      <Wrapper
        {...commonProps}

        typeOfStyle={diffMinutes <= 10 && !isSingle ? 'presentationTitleTiny' : heightContainer > 10 || isSingle ? 'presentationTitle' : 'presentationTitleSmall'}
        lineClamp={diffMinutes <= 35 && !isSingle ? 1 : diffMinutes <= 10 && !isSingle ? 2 : isSingle ? '' : 2}
        editorData={
          {
            editorType: diffMinutes <= 10 && !isSingle ? 'presentationTitleTiny' : heightContainer > 10 || isSingle ? 'presentationTitle' : 'presentationTitleSmall',
            ...commonData
          }
        }
      >
        {setLanguageContent(presentation, 'title', language)}
      </Wrapper>



      {!blurredBottom && !blurredTop ? descriptionContent : ''}

      {durationInHours > 1 && speakerContent || speakerContent && diffMinutes >= 30 || isSingle ? (
        <Wrapper
          {...commonProps}

          typeOfStyle={isSingle ? 'presentationSpeakerWrapperSingle' : 'presentationSpeakerWrapper'}
          editorData={
            {
              editorType: isSingle ? 'presentationSpeakerWrapperSingle' : 'presentationSpeakerWrapper',
              ...commonData
            }
          }
        >
          {speakerContent}
        </Wrapper>
      ) : ''}


      {
        isSingle || speakersLength > 3 || tracksLength >= 2 && speakersLength > 3 || tracksLength >= 2 && speakersLength > 2 && diffMinutes < 60 ? '' : companiesList.length && speakerContent ? (
          <Wrapper
            {...commonProps}

            typeOfStyle={'presentationCompanyLogoWrapper'}
            editorData={
              {
                editorType: 'presentationCompanyLogoWrapper',
                ...commonData
              }
            }
          >
            {companiesList}
          </Wrapper>
        ) : ''
      }
      {tags ? (
        <PresentationTagsWrapper>
          {tags.map((tagId, i) => {
            if (i > 3 && !isSingle || diffMinutes < 20 ) return;
            const fullTag = availableTags ? availableTags.find(tag => tag?.tagId === tagId) : '';
            return fullTag ? (
              <Wrapper
                {...commonProps}
                key={`RedAgendaPresentationTag-${fullTag.tagId}`}
                typeOfStyle={'templateTagWrapper'}
                editorData={
                  {
                    editorType: 'templateTagWrapper',
                    ...commonData
                  }
                }
                // onClick={() => this.handleIsTagActive(fullTag.tagId)}
              >
                <TagTextWrapper>
                  {fullTag.title}
                </TagTextWrapper>
              </Wrapper>
                ) : null;
              })}
        </PresentationTagsWrapper> 
      ) : null}

      {isSingle ? (
        <Wrapper
          {...commonProps}

          typeOfStyle={'linkClose'}
          editorData={
            {
              editorType: 'linkClose',
              ...commonData
            }
          }
          handleClick={this.handleClick}
        >
          {'Close'}
        </Wrapper>
      ) : (
        <Wrapper
          {...commonProps}

          typeOfStyle={diffMinutes <= 6 ? 'linkTiny' : 'link'}
          editorData={
            {
              editorType: diffMinutes <= 6 ? 'linkTiny' : 'link',
              ...commonData
            }
          }
          handleClick={this.handleClick}
        >
          {'See the details'}
        </Wrapper>
      )}
      {isSingle && allSortedDayPresentations.length > 1 ? (
        <>
          <Wrapper
            {...commonProps}

            typeOfStyle={prevPresentationDisabled ? 'prevPresentationDisabled' : 'prevPresentation'}
            editorData={
              {
                editorType: prevPresentationDisabled ? 'prevPresentationDisabled' : 'prevPresentation',
                ...commonData
              }
            }
            handleClick={prevPresentationDisabled ? null : this.handlePrevPresentation}
          />
          <Wrapper
            {...commonProps}

            typeOfStyle={nextPresentationDisabled ? 'nextPresentationDisabled' : 'nextPresentation'}
            editorData={
              {
                editorType: nextPresentationDisabled ? 'nextPresentationDisabled' : 'nextPresentation',
                ...commonData
              }
            }
            handleClick={nextPresentationDisabled ? null : this.handleNextPresentation}
          />
        </>
      )
        : ''}

    </Wrapper>)


    return (
      <PresentationWrapper
        hourOffset={getHoursOffset}
        hourOffsetHeight={styling && styling.rulerBlock ? styling.rulerBlock[0].height : 0}
        padding={styling && styling.rulerBlock ? styling.presentationContainer[0]['padding-top'] : 0}
        borderColor={styling && styling.rulerBlock ? styling.presentationContainer[0]['background-color'] : 0}
        howLong={diff}
        rowNumber={rowNumber}
        isUnder={trackCount && trackCount[trackKey] && rowNumber < trackCount[trackKey]}
        index={index}
        isSingle={isSingle}
        top={top}
      >

        {isSingle ? (
          <Wrapper
            {...commonProps}

            typeOfStyle={'fullScreenWrapper'}
            handleClick={commonProps.isEditor ? null : this.handleClick}
            editorData={
              {
                editorType: 'fullScreenWrapper',
                ...commonData
              }
            }
          >
            {presentationContent}
          </Wrapper>
        ) : presentationContent}
      </PresentationWrapper>
    );
  }
}

RedAgendaPresentation.propTypes = {
  commonData: PropTypes.object,
  openEditor: PropTypes.func,
  commonProps: PropTypes.object,
  presentation: PropTypes.any,
  dateFrom: PropTypes.object,
  dateTo: PropTypes.object,
  durationInHours: PropTypes.number,
  isSingle: PropTypes.bool,
  handleShowPresentation: PropTypes.func,
  speakers: PropTypes.array,
  firstHour: PropTypes.number,
  firstHourMinutes: PropTypes.number,
  blurredTop: PropTypes.bool,
  blurredBottom: PropTypes.bool,
  trackCount: PropTypes.object,
  tracksLength: PropTypes.number,
  index: PropTypes.number,
  top: PropTypes.string
};

export default RedAgendaPresentation;
